import { WorkQueueStatus } from '@operations/app/api'
import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { appStore } from 'modules/utils/src/stores/AppStore'

interface Props {
  open: boolean
  workQueueId?: number | null
  workQueueStatus?: WorkQueueStatus | null
  onClose: () => void
  onConfirm: () => void
}
export const StartWorkQueueDialog = observer(
  ({ open, workQueueId, workQueueStatus, onClose, onConfirm }: Props) => {
    const { t } = useTranslate()
    const { workQueueStore } = useOperationsStore()

    const handleStart = async () => {
      if (workQueueId) await workQueueStore.startWorkQueue(workQueueId)

      onConfirm()
      appStore.setShowAlert(
        'success',
        t('workQueueStarted', 'Work queue {status} successfully', {
          status:
            workQueueStatus === WorkQueueStatus.Stopped
              ? t('resumed', 'resumed')
              : t('started', 'started'),
        }),
      )
    }

    return (
      <ConfirmationDialog
        open={open}
        title={t('startWorkQueue', '{status} work queue?', {
          status:
            workQueueStatus === WorkQueueStatus.Stopped
              ? t('resume', 'Resume')
              : t('start', 'Start'),
        })}
        message={t(
          'startingWorkQueueMessage',
          '{status} the selected working queue will display the jobs on the operator devices',
          {
            status:
              workQueueStatus === WorkQueueStatus.Stopped
                ? t('resuming', 'Resuming')
                : t('starting', 'Starting'),
          },
        )}
        maxWidth='xs'
        primaryActionText={
          workQueueStatus === WorkQueueStatus.Stopped
            ? t('yesResume', 'Yes, resume')
            : t('yesStart', 'Yes, start')
        }
        primaryActionDataCy='crane-split-start-work-queue-confirm-btn'
        closeLabel={t('cancel', 'Cancel')}
        onClose={onClose}
        onConfirm={handleStart}
      />
    )
  },
)
